import React, { useEffect } from 'react';
import { createUseStyles, useTheme } from "react-jss";

import { PageInner } from "components/PageContainers";

const useStyles = createUseStyles({
  comments: {
    marginTop: '4rem'
  }
});

const BlogComments = ({ slug }) => {
  const theme = useTheme();
  const styles = useStyles({ theme });

  useEffect(() => {
    window.DiscourseEmbed = {
      discourseUrl: 'https://forum.edgeimpulse.com/',
      discourseEmbedUrl: `https://www.edgeimpulse.com/blog/${slug}`
    };

    var d = document.createElement('script'); d.type = 'text/javascript'; d.async = true;
    d.src = window.DiscourseEmbed.discourseUrl + 'javascripts/embed.js';
    (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(d);
  }, []);

  return (
    <PageInner>
      <div id="discourse-comments" className={styles.comments}></div>
    </PageInner>
  )
};

export default BlogComments;
